import { FeatureRole, Seller, User } from "types";
import { registerSnippet } from "./index";
import { createIframeAuthHost, getDefaultCredential, getDefaultSessionData } from "@/auth/iframeAuthHost";
import { config } from "@/config";
import { hasFeature } from "@/models/Seller";

const xchatUrl = config.xchat.ui;
const iframeUrl = `${xchatUrl}/customer.html`;

let authHost: { destroy: () => void } | null = null;

registerSnippet("XChat", !!xchatUrl, (user: User, seller: Seller, isXchatEnabled: boolean) => {
    if (!user && !seller) {
        console.log("%cError: Cannot load XChat because no user & seller specified", "color:red");
        return;
    }

    if (document.querySelector("#ui-xchat-container")) {
        if (!hasFeature(seller, FeatureRole.XCHAT) || !isXchatEnabled) {
            console.log("XChat is disabled for this seller, removing the widget.");
            document.querySelector("#ui-xchat-container")?.remove();
            authHost?.destroy();
            authHost = null;
            return;
        }

        console.log("XChat already exists, skipping this.");
        return;
    }

    if (!hasFeature(seller, FeatureRole.XCHAT) || !isXchatEnabled) {
        console.log("XChat customer widget is disabled.");
        return;
    }

    const params = {
        seller: seller.id,
        user: user.id,
    };
    const account = new URLSearchParams(params).toString();

    const widths = { open: "480", closed: "80" };
    const heights = { open: "770", closed: "60" };
    const iframe = document.createElement("iframe");
    iframe.id = "ui-xchat-container";
    iframe.src = `${iframeUrl}?${account}`;
    iframe.width = widths.closed;
    iframe.height = heights.closed; // By default, it's in a closed height mode
    iframe.style.position = "fixed";
    iframe.style.bottom = "0";
    iframe.style.right = "0";
    iframe.style.zIndex = "30";
    iframe.style.display = "block";

    document.body.append(iframe);

    const xchatOrigin = new URL(xchatUrl).origin;

    const authHostInstance = createIframeAuthHost({
        getIframeWindow: () => document.querySelector<HTMLIFrameElement>("#ui-xchat-container")?.contentWindow ?? null,
        origin: xchatOrigin,
        getCredential: getDefaultCredential,
        getSessionData: () => getDefaultSessionData(xchatOrigin),
    });
    authHost = authHostInstance;

    window.addEventListener("message", function (event) {
        if (event.origin !== xchatOrigin) return;
        if (event.data.xchat) {
            const { xchat } = event.data;
            switch (xchat.eventName) {
                case "close":
                    iframe.width = widths.closed;
                    iframe.height = heights.closed;
                    break;
                case "open":
                    iframe.width = widths.open;
                    iframe.height = heights.open;
                    break;
                default:
                    break;
            }
        }
    });
});
